"use strict";
/**
 * Pure helpers for the Metrics admin view.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMetricsCategoryId = exports.areMetricsSchemasEqual = exports.cloneMetricsSchema = void 0;
exports.cloneMetricsSchema = function (schema) {
    return schema.map(function (category) { return (__assign(__assign({}, category), { properties: category.properties.map(function (property) { return (__assign(__assign({}, property), { useCases: property.useCases.map(function (useCase) { return (__assign({}, useCase)); }) })); }) })); });
};
exports.areMetricsSchemasEqual = function (left, right) {
    return JSON.stringify(left) === JSON.stringify(right);
};
exports.generateMetricsCategoryId = function (existing) {
    var base = 'category';
    var used = new Set(existing.map(function (category) { return category.id; }));
    var index = existing.length + 1;
    var candidate = base + "-" + index;
    while (used.has(candidate)) {
        index += 1;
        candidate = base + "-" + index;
    }
    return candidate;
};
